function h(n) {
  const e = [], s = n.nodes.length;
  return n.nodes.forEach((c, r) => {
    for (const t of Object.values(c.values ?? {})) "node" in t && l(t.node, s) && e.push([t.node, r]);
    for (const t of Object.values(c.flows ?? {})) l(t.node, s) && e.push([r, t.node]);
  }), e;
}
function a(n) {
  const e = n.nodes.length, s = Array.from({ length: e }, () => []), c = new Array(e).fill(0);
  for (const [o, f] of h(n))
    s[o].push(f), c[f]++;
  const r = [];
  for (let o = 0; o < e; o++) c[o] === 0 && r.push(o);
  const t = [];
  for (; r.length > 0; ) {
    const o = r.shift();
    t.push(o);
    for (const f of s[o]) --c[f] === 0 && d(r, f);
  }
  if (t.length === e) return {
    ok: !0,
    order: t
  };
  const u = /* @__PURE__ */ new Set();
  for (let o = 0; o < e; o++) c[o] > 0 && u.add(o);
  return {
    ok: !1,
    cycles: p(s, u)
  };
}
function w(n) {
  const e = a(n);
  return e.ok ? [] : e.cycles;
}
function y(n) {
  const e = new Array(n.length);
  return n.forEach((s, c) => {
    e[s] = c;
  }), e;
}
function l(n, e) {
  return typeof n == "number" && Number.isInteger(n) && n >= 0 && n < e;
}
function d(n, e) {
  let s = 0;
  for (; s < n.length && n[s] < e; ) s++;
  n.splice(s, 0, e);
}
function p(n, e) {
  const s = [], c = /* @__PURE__ */ new Set();
  for (const r of [...e].sort((t, u) => t - u)) {
    if (c.has(r)) continue;
    const t = g(r, n, e);
    if (t) {
      for (const u of t) c.add(u);
      s.push(t);
    }
  }
  return s;
}
function g(n, e, s) {
  const c = /* @__PURE__ */ new Map(), r = [n], t = /* @__PURE__ */ new Set([n]);
  for (; r.length > 0; ) {
    const u = r.shift();
    for (const o of [...e[u]].sort((f, i) => f - i))
      if (s.has(o)) {
        if (o === n) {
          const f = [u];
          let i = u;
          for (; i !== n; )
            i = c.get(i), f.push(i);
          return f.reverse(), f.push(n), f;
        }
        t.has(o) || (t.add(o), c.set(o, u), r.push(o));
      }
  }
  return null;
}
export {
  y as n,
  a as r,
  w as t
};

//# sourceMappingURL=graphOrdering-DH1LjtCN.js.map